import { type FC } from 'react';
import { ActiveBoundaryContainer } from '~/sidebar/sidebarApps/mapTools/boundary/activeBoundary/activeBoundary.container';
import { useBoundaryToolBTGsGroupedByBoundaryGroupSelector } from '~/store/boundaryTerritoryGroups/boundaryTool/boundaryToolBTGs.selectors';
import { useMapSettingsExportImageAllowedBoundaryGroupsSelector } from '~/store/mapSettings/toolsState/exportImageSettings/exportImageSettings.selectors';

type ActiveBoundariesComponentProps = {
  legendMode?: boolean;
};

export const ActiveBoundariesComponent: FC<ActiveBoundariesComponentProps> = ({ legendMode }) => {
  const boundaryTerritoryGroupsByBoundaryGroupId = useBoundaryToolBTGsGroupedByBoundaryGroupSelector();
  const allowedBoundaryGroups = useMapSettingsExportImageAllowedBoundaryGroupsSelector();

  return (
    <>
      {boundaryTerritoryGroupsByBoundaryGroupId
        .filter(({ boundaryGroupId }) => !allowedBoundaryGroups || allowedBoundaryGroups.includes(boundaryGroupId))
        .map(({ boundaryGroupId, boundaryTerritoryGroups }) => (
          <ActiveBoundaryContainer
            key={boundaryGroupId}
            boundaryGroupId={boundaryGroupId}
            boundaryTerritoryGroups={boundaryTerritoryGroups}
            legendMode={legendMode}
          />
        ))}
    </>
  );
};
